import React from "react";

// P2 social proof — recognisable institutions whose research/news the feed
// covers. Favicons via icon.horse (free, keyless — same pattern as NewsCard).
const SOURCES = [
  { name: "WTTC", domain: "wttc.org" },
  { name: "OECD", domain: "oecd.org" },
  { name: "UN Tourism", domain: "unwto.org" },
  { name: "Skift", domain: "skift.com" },
  { name: "Phocuswright", domain: "phocuswright.com" },
  { name: "McKinsey", domain: "mckinsey.com" },
];

const TrustedSourcesStrip = ({ darkMode }) => {
  const dm = darkMode;
  return (
    <div data-testid="trusted-sources-strip" className="mb-8">
      <p className={`category-tag mb-3 ${dm ? "text-slate-600" : "text-[#bac9cc]"}`}>
        Covering research &amp; news from
      </p>
      <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
        {SOURCES.map(({ name, domain }) => (
          <div
            key={domain}
            data-testid={`trusted-source-${domain.split(".")[0]}`}
            className="flex items-center gap-2 opacity-55 hover:opacity-100 transition-opacity"
            title={name}
          >
            <img
              src={`https://icon.horse/icon/${domain}`}
              alt=""
              aria-hidden="true"
              width={18}
              height={18}
              loading="lazy"
              className="w-[18px] h-[18px] rounded-sm object-cover grayscale"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
            <span className={`text-sm font-semibold tracking-tight ${dm ? "text-slate-400" : "text-[#3b494c]"}`}>
              {name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustedSourcesStrip;
